import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Avatar,
  Flex,
  GridItem,
  Text,
  SimpleGrid,
} from "@chakra-ui/react";
import { handleStringManupulation } from "../../../../utils/customHooks";
import { getMyExperts } from "../../../../modules/actions";
import Loader from "../../../../common/components/Loader";
import "../myProfile.css";

const Expert = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.profile);
  const childExperts = useSelector((state) => state.childExperts);
  const { apiLoader } = useSelector((state) => state?.loader);

  useEffect(() => {
    dispatch(getMyExperts());
  }, [dispatch]);

  return (
    <Box id="mainWrapper" px="16px" py="24px">
      <Text className="txnsTabText1">Expert</Text>
      <Text className="txnsTabText2">
        Information about your child’s expert
      </Text>
      {apiLoader ? (
        <Loader text="Loading, Please Wait..." />
      ) : (
        childExperts.map((expert) => {
          return (
            <>
              <Flex className="parentProfileMainBodyContainer">
                <Avatar
                  className="parentProfileAvatar"
                  name={expert?.fullName}
                  src={expert?.image}
                />
                <Flex flexDirection="column" ml="16px" justifyContent="center">
                  <Text className="profileChildName">{expert?.fullName}</Text>
                  <Flex mt="4px">
                    <Text className="profileAgeGender">{expert?.bio}</Text>
                  </Flex>
                </Flex>
              </Flex>
              <SimpleGrid
                rowGap="16px"
                gridTemplateColumns={{ base: "1 1fr", sm: "160px 1fr" }}
                className="parentProfileMainBodyContainer2"
              >
                <GridItem colSpan="160px">
                  <Text className="servicesMainBodyTitle">Qualification</Text>
                </GridItem>
                <GridItem colSpan={1}>
                  {expert.qualifications.map((qualification) => (
                    <Text className="servicesMainBodyTitleDesc">
                      {qualification.degree +
                        " - " +
                        qualification.fieldOfStudy}
                    </Text>
                  ))}
                </GridItem>
                <GridItem colSpan="160px">
                  <Text className="servicesMainBodyTitle">Service Type</Text>
                </GridItem>
                <GridItem colSpan={1}>
                  <Text className="servicesMainBodyTitleDesc">
                    {handleStringManupulation(expert?.serviceTypes)}
                  </Text>
                </GridItem>
                <GridItem colSpan="160px">
                  <Text className="servicesMainBodyTitle">Experience</Text>
                </GridItem>
                <GridItem colSpan={1}>
                  <Text className="servicesMainBodyTitleDesc">
                    {expert.yearsOfExperience} years
                  </Text>
                </GridItem>
                <GridItem colSpan="160px">
                  <Text className="servicesMainBodyTitle">Conditions</Text>
                </GridItem>
                <GridItem colSpan={1}>
                  <Text className="servicesMainBodyTitleDesc">
                    {handleStringManupulation(expert?.condition)}
                  </Text>
                </GridItem>

                <GridItem colSpan="160px">
                  <Text className="servicesMainBodyTitle">Age range</Text>
                </GridItem>
                <GridItem colSpan={1}>
                  <Text className="servicesMainBodyTitleDesc">
                    {expert?.startingAgeRange} to {expert?.endingAgeRange} year
                    old
                  </Text>
                </GridItem>
                <GridItem colSpan="160px">
                  <Text className="servicesMainBodyTitle">Language</Text>
                </GridItem>
                <GridItem colSpan={1}>
                  <Text className="servicesMainBodyTitleDesc">
                    {handleStringManupulation(expert.languages)}
                  </Text>
                </GridItem>
              </SimpleGrid>
            </>
          );
        })
      )}
    </Box>
  );
};

export default Expert;
